export const isEmbedded = process.env.RENDER_MODE === 'embedded';
